module.exports = __webpack_public_path__ + "static/media/AdobeCC_Step2b_Image15g.4e3020df.jpg";